import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import "@/App.css";

import Landing from "@/pages/Landing";
import UserInfo from "@/pages/UserInfo";
import Assessment from "@/pages/Assessment";
import Results from "@/pages/Results";
import Report from "@/pages/Report";
import QRPage from "@/pages/QRPage";
import PersonalInfo from "@/pages/personal/PersonalInfo";
import PersonalAssessment from "@/pages/personal/PersonalAssessment";
import PersonalReport from "@/pages/personal/PersonalReport";
import CohortEntry from "@/pages/cohort/CohortEntry";
import CohortProfile from "@/pages/cohort/CohortProfile";
import CohortAssessment from "@/pages/cohort/CohortAssessment";
import CohortAfter from "@/pages/cohort/CohortAfter";
import ConsultantDashboard from "@/pages/cohort/ConsultantDashboard";
import B2MConsultantDashboard from "@/pages/b2m/B2MConsultantDashboard";
import B2MAssessment from "@/pages/b2m/B2MAssessment";
import B2MOrgReport from "@/pages/b2m/B2MOrgReport";
import BGAssessment from "@/pages/bg/BGAssessment";
import Campaigns from "@/pages/ai/Campaigns";
import CampaignWizard from "@/pages/ai/CampaignWizard";
import CampaignView from "@/pages/ai/CampaignView";
import BusinessClarity from "@/pages/BusinessClarity";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/mula" element={<UserInfo />} />
          <Route path="/soalan" element={<Assessment />} />
          <Route path="/result/:id" element={<Results />} />
          <Route path="/report/:id" element={<Report />} />
          <Route path="/qr" element={<QRPage />} />
          <Route path="/personal/mula" element={<PersonalInfo />} />
          <Route path="/personal/soalan" element={<PersonalAssessment />} />
          <Route path="/personal/report/:id" element={<PersonalReport />} />
          <Route path="/cohort" element={<CohortEntry />} />
          <Route path="/cohort/mula" element={<CohortProfile />} />
          <Route path="/cohort/soalan" element={<CohortAssessment />} />
          <Route path="/cohort/after" element={<CohortAfter />} />
          <Route path="/cohort/consultant" element={<ConsultantDashboard />} />
          <Route path="/b2m/consultant" element={<B2MConsultantDashboard />} />
          <Route path="/b2m/assess/:pid" element={<B2MAssessment />} />
          <Route path="/bg/assess/:pid" element={<BGAssessment />} />
          <Route path="/b2m/org/:code" element={<B2MOrgReport />} />
          <Route path="/campaigns" element={<Campaigns />} />
          <Route path="/campaigns/new" element={<CampaignWizard />} />
          <Route path="/campaigns/:id" element={<CampaignView />} />
          <Route path="/business-clarity" element={<BusinessClarity />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-center" richColors />
    </div>
  );
}

export default App;
